import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./Redux/user/user";
import defaultSelectionsReducer from "./Redux/defaultSelections/defaultSelections";

export const store = configureStore({
	reducer: {
		user: userReducer,
		defaultSelections: defaultSelectionsReducer,
	},
});
